import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Kicker, Reveal } from "../components/Reveal";
import { BUSINESS } from "../lib/data";

const CONTACTS = [
  { icon: Phone, label: BUSINESS.phone, href: BUSINESS.phoneHref, testid: "visit-phone-link" },
  { icon: Mail, label: BUSINESS.email, href: `mailto:${BUSINESS.email}`, testid: "visit-email-link" },
  { icon: Instagram, label: BUSINESS.instagram, href: BUSINESS.instagramUrl, testid: "visit-instagram-link", external: true },
];

export default function VisitSection() {
  return (
    <section id="visit" data-testid="visit-section" className="border-t border-linen bg-ivory py-20 sm:py-28">
      <div className="mx-auto grid max-w-7xl items-start gap-14 px-6 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <Kicker>Visit Us</Kicker>
          <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight text-forest sm:text-5xl">
            Inside Salon 406, North Ogden
          </h2>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-moss sm:text-base">
            A private suite within Salon 406 — easy parking, a calm space, and
            appointments that never feel rushed. Visits are by appointment only.
          </p>

          <div className="mt-9 space-y-3">
            {CONTACTS.map((c) => (
              <a
                key={c.testid}
                href={c.href}
                data-testid={c.testid}
                target={c.external ? "_blank" : undefined}
                rel={c.external ? "noreferrer" : undefined}
                className="flex items-center gap-3 text-forest transition-colors hover:text-gold-dark"
              >
                <c.icon size={16} className="shrink-0 text-moss" />
                <span className="break-all text-sm font-medium">{c.label}</span>
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="rounded-lg border border-linen p-9 sm:p-12">
            <MapPin size={20} className="text-moss" />
            <p className="mt-6 font-serif text-3xl font-medium leading-snug text-forest sm:text-4xl">
              {BUSINESS.addressLines[0]}
              <br />
              {BUSINESS.addressLines[1]}
              <br />
              {BUSINESS.addressLines[2]}
            </p>
            <p className="mt-5 text-sm text-moss">By appointment only</p>
            <a
              href={BUSINESS.mapsUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="visit-directions-button"
              className="mt-8 inline-block rounded-md bg-forest px-6 py-3 text-sm font-semibold text-ivory transition-colors duration-300 hover:bg-forest-dark"
            >
              Get Directions
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
